import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { TaskItem, toTaskItemXML } from '../../dataObjects/TaskItem';

export interface ICreateIssueRequest extends IBaseRequest {
  ITEM: TaskItem;
}

export class CreateIssueRequest extends BaseRequest implements ICreateIssueRequest {
  public ITEM: TaskItem;

  constructor(server: string, session: string, item: TaskItem) {
    super(server, session);
    this.ITEM = item;
  }

  public toXml(): string {
    let parameters: string = super.toXml();

    parameters += '<ITEM>';
    parameters += toTaskItemXML(this.ITEM);
    parameters += '</ITEM>';

    return super.wrapperXml('CreateIssue', parameters);
  }
}
